<template>
  <div class="home">
	    <div class="box">	
			<div class="level">
				<div class="level-left">
					<router-link to="/volunteers/add"><button class="button is-success">Add New Volunteer</button></router-link>
				</div>
				<div class="level-right">
					<input type="text" v-model="search" class="input" placeholder="Search ..."/>
				</div>
			</div>
			

           <table class="table is-fullwidth is-hoverable" v-if="loading === false && filteredVolunteers.length > 0">
               <thead>
                   <tr>
                       <th>Name</th>
                       <th>Email</th>
					   <th>App Login</th>
					   <th>Hours Logged</th>
                      <th width="50">&nbsp;</th>
                       </tr>
                   </thead>
				   <tbody>
					   <tr v-for="row in filteredVolunteers" :key="row.id">
						   <td><router-link :to="'/volunteers/' + row.id">{{ row.forename }} {{ row.surname }}</router-link></td>
                            <td>{{ row.email }}</td>
							<td>
								<span v-if="row.auth0 != ''">Already setup</span>
								<button class="button is-small is-success" v-if=" row.auth0 == '' || row.auth0 == null" @click="createAuth0Login(row)" :disabled="working == true">Create Login</button>

							</td>
							<td>{{ totalHours(row) }}</td>
						    <td>
                                <router-link :to="'/volunteers/' + row.id"><button class="button is-info is-small">View</button></router-link>
                            </td>
						   </tr>
					</tbody>
            </table>

            <div class="notification is-warning" v-if="loading === true">Loading ...</div>
			<div class="notification is-info" v-if="loading === false && volunteers.length === 0">There are no volunteers added yet</div>

            <router-link to="/volunteers/add"><button class="button is-success">Add New Volunteer</button></router-link>
        </div>
		
	</div>
</template>

<script>
import AwardsService from '@/services/AwardsService.js';

export default {
  name: 'Home',
	
	data: function () {
    	return {
		      volunteers: [],
			  loading : true,
			  working:false,
			  search: "",
				API_NAME: process.env.VUE_APP_API_NAME,
				accessToken: ''
		}
	},
	created() {
      this.getAccessToken()
        .then(() => { 
           this.getVolunteers();
		
        });
      
    },
	methods: {
		async getAccessToken() {
            this.accessToken = await this.$auth.getTokenSilently()
        },
		// Log the user in
		login() {
			this.$auth.loginWithRedirect();
		},
		async getVolunteers() {
			this.loading = true
			AwardsService.getVolunteers(this.accessToken, this.search)
			.then(
				(volunteers => {
				this.$set(this, "volunteers", volunteers);
                this.loading = false
				this.working = false
				}).bind(this)
			);
		},
		async createAuth0Login(user) {
			this.working = true
			
			if(confirm(' Are you sure you want to create a login for this user to access the database ?'))
			{
				var formdata = { 
                 
                }; 
				
				AwardsService.createAuth0UserLogin(this.accessToken, user.id, formdata)
				.then(() => (this.getVolunteers()))
				.catch( error => {
					if(error.response.status == 404)
					{
						alert("ERROR : The user you are trying to update cannot be found")
						console.log(error.response)
					}
					else{
						alert("Something has gone wrong. Please try again or contact David - " + error.response.statusText)
						console.log(error.response)
					}
					
				})
			}
			else{
				this.working = false
				return false;
			}
			
		},
		totalHours(user)
		{
			let totalHours = 0

			totalHours = user.hours.reduce(
				(previousValue, currentValue) => previousValue + parseFloat(currentValue.hours), 0
			)

			if(totalHours == 0)
			{
				totalHours = "None yet"
			}

			return totalHours
		}
		
		
	},
	computed : {
      filteredVolunteers: function () {
        let filteredVolunteers = []
       
          if(this.search != '' && this.search != null)
          {
           filteredVolunteers = this.volunteers.filter(row => row.forename.toLowerCase().includes(this.search.toLowerCase()) || row.surname.toLowerCase().includes(this.search.toLowerCase()))
          }
		  else{
			filteredVolunteers = this.volunteers
		  }

          return filteredVolunteers
       
     }
  },

  mounted() {
    if (localStorage.search) {
      this.search = localStorage.search;
    }
    else{
      this.search = ''
    }

},
	watch: {
    'search'() {
      localStorage.search = this.search
      
    },
}
	
}
</script>
